// counting-circle-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CircleData {
    current: number;
    versus: number;
    variation: number;
    icon: string;
}

@Injectable({ providedIn: 'root' })
export class CountingCircleStateService {
    private _circleData$ = new BehaviorSubject<CircleData | null>(null);
    public circleData$ = this._circleData$.asObservable();

    public emit(data: CircleData): void {
        this._circleData$.next(data);
    }

    public setLoading(): void {
        this._circleData$.next(null);
    }
}
